import { OptionVariationData } from '../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../localization/SiteTranslation';
import { Subtitle1 } from '../../../shared/components/Typography/Subtitle';
import css from './FabricFacetFilters.css';
import FabricFacetFiltersDropdowns from './FabricFacetFiltersDropdowns/FabricFacetFiltersDropdowns';
import FabricFacetFiltersModal from './FabricFacetFiltersModal/FabricFacetFiltersModal';
import FabricFacetFiltersState from './FabricFacetFiltersState';

interface FabricFacetFiltersProps {
  state: FabricFacetFiltersState;
  total: number;
  translation: FabricFacetFiltersTranslation;
  allItems: Array<OptionVariationData>;
}

export const FabricFacetFilters = ({ state, total, translation, allItems }: FabricFacetFiltersProps) => {
  return (
    <div className={css.root}>
      <FabricFacetFiltersModal
        className={css.modal}
        state={state.modal}
        translation={translation}
        allItems={allItems}
      />
      <FabricFacetFiltersDropdowns
        className={css.dropdowns}
        state={state}
        total={total}
        translation={translation}
        allItems={allItems}
      />
    </div>
  );
};
